import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Truncate from 'react-truncate';
import { useTranslation } from 'react-i18next';

import Scrollbar from '../../../Scrollbar';

function CompareDegreesSection(props) {
  const {
    dynamicTitleTextColor,
    dynamicCareersColor,
    dynamicSectionClass,
    dynamicSectionTitle,
    checkMainSectionsDisplay,
    degreeList,
    addLine,
  } = {
    ...props,
  };

  const { t } = useTranslation();

  // Send the degree to compare to the redux store
  const handleDegreeSelected = (degree) => {
    // Set the double query parameters in the URL
    const params = new URLSearchParams(props.location.search);
    const firstDegree = params.get('degree');

    // Is this the first career modal to open or the second?
    if (firstDegree) {
      const [firstDegreeTitle, firstDegreeId] = firstDegree.split('degreeId');

      props.history.push({
        search: props.location.pathname.includes('user-profile')
          ? `?userId=${props.userProfileId}&tenantId=${
              props.userProfileTenantId
            }&degree=${encodeURIComponent(
              firstDegreeTitle
            )} degreeId ${firstDegreeId}&degree2=${encodeURIComponent(
              degree.titleEn
            )} degreeId ${degree.id}&swap=false`
          : `?degree=${encodeURIComponent(
              firstDegreeTitle
            )} degreeId ${firstDegreeId}&degree2=${encodeURIComponent(
              degree.titleEn
            )} degreeId ${degree.id}&swap=false`,
        state: props.location.pathname.includes('user-profile')
          ? {
              userId: props.userProfileId,
              tenantId: props.userProfileTenantId,
            }
          : null,
      });
    } else {
      props.history.push({
        search: `?degree=${encodeURIComponent(degree.titleEn)} degreeId ${
          degree.id
        } &swap=false`,
      });
    }

    // Redisplay original degree content for this modal
    checkMainSectionsDisplay(true);
  };

  const makeTempDegreeList = (tempList) => {
    const sorted =
      dynamicSectionTitle !== t('All Degrees For Career')
        ? tempList.sort((a, b) => (a.titleEn > b.titleEn ? 1 : -1))
        : tempList;

    return sorted.map((degree) => (
      <li
        data-cy="career-item"
        className={[
          'career-item',
          dynamicSectionClass,
          dynamicCareersColor,
        ].join(' ')}
        key={degree.id}
      >
        <Truncate
          lines={1}
          ellipsis="..."
          onClick={() => handleDegreeSelected(degree)}
          onKeyDown={() => handleDegreeSelected(degree)}
          className="career-item-text"
        >
          {' '}
          <button
            role="link"
            tabIndex={0}
            type="button"
            data-cy="career-item-text"
          >
            {degree.titleEn}
          </button>
        </Truncate>
      </li>
    ));
  };

  return (
    <>
      <Scrollbar className={dynamicSectionClass}>
        <div className={['career-list', dynamicSectionClass].join(' ')}>
          <p
            className={[
              'list-title',
              dynamicTitleTextColor,
              dynamicSectionClass,
            ].join(' ')}
          >
            {dynamicSectionTitle}
          </p>

          <ul data-cy="degree-section-list">
            {makeTempDegreeList(degreeList)}
          </ul>
        </div>
      </Scrollbar>
      {addLine ? <hr className="horizontal-line" /> : null}
    </>
  );
}

const mapStateToProps = (state) => {
  const userProfileId = state.admin.userProfileInfo?.id;
  const userProfileTenantId = state.admin.userProfileInfo?.tenantId;

  return { userProfileId, userProfileTenantId };
};

const compareDegreesSectionWithRouter = withRouter(
  connect(mapStateToProps)(CompareDegreesSection)
);

export default compareDegreesSectionWithRouter;
